module.exports = "./img/d272b2f6680a392b254f4fc2af552e90.jpg";